import { invokeApi } from '../axios'
import { change } from 'redux-form'
import {
  FETCH_WELCOMES_REQUEST,
  FETCH_WELCOMES_SUCCESS,
  FETCH_WELCOMES_FAIL,
  SAVE_WELCOME_REQUEST,
  SAVE_WELCOME_SUCCESS,
  SAVE_WELCOME_FAIL,
  DELETE_WELCOME_REQUEST,
  DELETE_WELCOME_SUCCESS,
  DELETE_WELCOME_FAIL,
  WELCOME_TYPE_CHANGE,
  PUBLISH_WELCOME,
  UNPUBLISH_WELCOME,
  LOAD_WELCOME,
  CLEAR_WELCOME_STATE,
  SORT_WELCOME_TYPE_CHANGE,
  SEARCH_WELCOME,
  CHANGE_WELCOME_PAGE,
} from './types'

export const welcomeTypeChange = welcomeType => dispatch => {
  dispatch(change('welcomeForm', 'ctaText', welcomeType.coachmark))
  dispatch({ type: WELCOME_TYPE_CHANGE, welcomeType })
}

export const fetchWelcomes = () => dispatch => {
  dispatch({ type: FETCH_WELCOMES_REQUEST })
  return invokeApi({ url: '/welcomes' })
    .then(results => results.data)
    .then(welcomes => dispatch({ type: FETCH_WELCOMES_SUCCESS, welcomes }))
    .catch(error => dispatch({ type: FETCH_WELCOMES_FAIL, error }))
}

export const saveWelcome = (welcomeId = '') => (dispatch, getState) => {
  dispatch({ type: SAVE_WELCOME_REQUEST })

  const formParams = getState().form.welcomeForm.values
  const welcomeState = getState().welcome

  let ctaAction = welcomeState.welcomeType.value

  const params = {
    ...formParams,
    ctaAction,
  }

  let url = welcomeId ? `/welcomes/${welcomeId}` : '/welcomes'

  invokeApi({
    url,
    data: params,
    method: 'post',
  })
    .then(results => results.data)
    .then(welcome => {
      dispatch({ type: SAVE_WELCOME_SUCCESS })
    })
    .catch(error => dispatch({ type: SAVE_WELCOME_FAIL }))
}

export const deleteWelcome = welcomeId => dispatch => {
  dispatch({ type: DELETE_WELCOME_REQUEST })
  invokeApi({
    url: `/welcomes/${welcomeId}`,
    method: 'delete',
  })
    .then(results => results.data)
    .then(() =>
      dispatch({
        type: DELETE_WELCOME_SUCCESS,
        welcomeId,
      }),
    )
    .catch(error =>
      dispatch({
        type: DELETE_WELCOME_FAIL,
        error: 'Failed to delete welcome',
      }),
    )
}

export const loadWelcome = welcomeId => dispatch =>
  dispatch({ type: LOAD_WELCOME, welcomeId })

export const publishWelcome = welcomeId => async (dispatch, getState) => {
  const welcome = getState().welcome.welcomes.find(
    welcome => welcome.id === welcomeId,
  )

  welcome.active = true

  try {
    await invokeApi({
      url: `/welcomes/publish/${welcomeId}`,
      data: welcome,
      method: 'post',
    })
    dispatch({ type: PUBLISH_WELCOME, welcomeId: welcome.id })
  } catch (error) {
    console.error(error)
  }
}

export const unpublishWelcome = welcomeId => async (dispatch, getState) => {
  const welcome = getState().welcome.welcomes.find(
    welcome => welcome.id === welcomeId,
  )

  welcome.active = false

  try {
    await invokeApi({
      url: `/welcomes/publish/${welcomeId}`,
      data: welcome,
      method: 'post',
    })
    dispatch({ type: UNPUBLISH_WELCOME, welcomeId: welcome.id })
  } catch (error) {
    console.error(error)
  }
}

export const clearWelcomeState = () => dispatch =>
  dispatch({ type: CLEAR_WELCOME_STATE })

export const sortWelcomeTypeChange = sortType => dispatch => {
  dispatch({ type: SORT_WELCOME_TYPE_CHANGE, sortType })
}

export const searchWelcome = searchString => dispatch => {
  dispatch({ type: SEARCH_WELCOME, searchString })
}

export const changeWelcomePage = page => dispatch => {
  dispatch({ type: CHANGE_WELCOME_PAGE, page })
}
